import { landingStyles } from '../landing.styles';

interface LandingCardProps {
	id: string;
	title: string;
	image: string;
	imageAlt: string;
	description: string;
	buttonText: string;
	onButtonClick: () => void;
}

export const LandingCard = ({
	id,
	title,
	image,
	imageAlt,
	description,
	buttonText,
	onButtonClick,
}: LandingCardProps) => {
	return (
		<div className="card" id={id} style={landingStyles.card}>
			<h3 style={landingStyles.cardTitle}>{title}</h3>
			<img src={image} alt={imageAlt} style={landingStyles.cardImage} />
			<p style={landingStyles.cardText}>{description}</p>
			<button 
				style={landingStyles.btnOutline}
				onClick={onButtonClick}
			>
				{buttonText}
			</button>
		</div>
	);
};

